import { Routes } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';
import { AreaRoleGuard } from './core/guards/area-role.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'auth/login',
    pathMatch: 'full'
  },
  {
    path: 'auth',
    loadChildren: () => import('./auth/authentication/authentication.routes')
  },

  {
    path: 'home',
    canActivate: [AuthGuard], 
    loadChildren: () => import('./home/pages/home.routes')
  },
  {
    path: 'init-app', 
    loadChildren: () => import('./init-app/init-app.routes') 
  },
  {
    path: 'init-app-general',
    loadChildren: () => import('./init-app-general/init-app-general.routes')
  },
  {
    path: 'init-app-sistemas',
    loadChildren: () => import('./init-app-sistemas/init-app-sistemas.routes')
  },
  {
    path: 'init-app-contabilidad',
    loadChildren: () => import('./init-app-contabilidad/init-app-contabilidad.routes')
  },
  {
    path: 'init-app-supervision',
    loadChildren: () => import('./init-app-supervision/init-app-supervision.routes')
  },
  {
    path: 'init-app-gerencia',
    canActivate: [AuthGuard, AreaRoleGuard],
    data: { area: 'GERENCIA' },
    loadChildren: () => import('./init-app-gerencia/init-app-gerencia.routes')
  },
  {
    path: 'init-app-ceo',
    canActivate: [AuthGuard, AreaRoleGuard],
    data: { area: 'CEO' },
    loadChildren: () => import('./init-app-ceo/init-app-ceo.routes')
  },

  


  {
    path: '**',
    redirectTo: 'auth/login'
  }
];
